<template>
  <div>
    <el-form :model="searchForm" class="search-form">
      <el-form-item prop="agentName" label-width="100">
        <el-input :maxlength="255" v-model="searchForm.agentName" placeholder="所属分销代理/ID" />
      </el-form-item>
      <el-form-item prop="fansIdOrName" label-width="100">
        <el-input :maxlength="255" v-model="searchForm.fansIdOrName" placeholder="达人昵称/达人ID" />
      </el-form-item>
      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table header-row-class-name="header" border highlight-current-row :data="table.dataSource"
      v-loading="table.loading">
      <el-table-column width="250" label="账号信息" prop="itemCreateTimeStr">
        <template slot-scope="{ row }">
          <div class="table-user">
            <img :src="row.headImage
              ? row.headImage
              : require('../../../../assets/img/default_img.png')
              " />
            <div class="table-user__right">
              <div>{{ row.userName }}</div>
              <div>达人ID：{{ row.reference }}</div>
              <div>绑定时间：{{ row.createTimeStr }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属分销代理" prop="agentName">
      </el-table-column>
      <el-table-column label="结佣比例" width="180">
        <template slot-scope="{ row }">
          <settle-record :row="row" />
        </template>
      </el-table-column>

      <el-table-column label="销售溢价" width="180">
        <template slot-scope="{ row }">
          <commission-record :row="row" />
        </template>
      </el-table-column>

      <el-table-column label="待结佣金额(元)" prop="waitSettle">
      </el-table-column>
      <el-table-column label="已结佣金额(元)" prop="settled">
      </el-table-column>

    </el-table>
    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total">
    </el-pagination>
  </div>
</template>

<script>
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
import settleRecord from "./SettleRecord";
import commissionRecord from "./CommissionRecord";
const searchParams = {
  // 搜素表单
  agentName: "",// 代理名称
  fansIdOrName: "", // 粉丝ID或者名称
}
export default {
  props: {
    activeName: {
      // 激活名称
      type: String,
    },
    agentName: {
      // 代理名称
      type: String
    }
  },
  components: {
    settleRecord,
    commissionRecord,
  },

  data() {
    return {
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
    };
  },
  watch: {
    activeName: {
      immediate: true,
      handler: async function () {
        if (this.activeName === "second") {
          this.searchForm.agentName = this.agentName
          this.freshTable();

        }
      },
    },
  },
  methods: {
    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 表单重置`
    onFormReset() {
      this.searchForm = Object.assign({}, searchParams);
      this.searchForm.fansIdOrName = "";
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      const data = await DouYinModel.getAgencyMasterPageKs({
        ...this.pagination,
        ...this.searchForm,
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/distribution/AgencyMaster.vue